export default __webpack_public_path__ + "84be3029e411f4f0fa47468d2cc7ebb8.svg";